(function () {
  var sectionSelector = '.kev-hair-needs[data-section-id]';

  function normalizeBg(raw) {
    return (raw || '').replace(/[\r\n]+/g, ' ').replace(/\s{2,}/g, ' ').trim();
  }

  function activateSection(section) {
    if (!section || section.dataset.hairNeedsActivated === '1') return;
    section.dataset.hairNeedsActivated = '1';
    section.classList.add('kev-hair-needs--enhanced');

    var track = section.querySelector('[data-carousel-track]');
    var prevBtn = section.querySelector('[data-carousel-prev]');
    var nextBtn = section.querySelector('[data-carousel-next]');
    var status = section.querySelector('[data-carousel-status]');
    var dotsWrap = section.querySelector('[data-carousel-dots]');
    var counter = section.querySelector('[data-carousel-counter]');
    var defaultBg = normalizeBg(section.dataset.defaultBg);
    var dotCount = -1;
    var suppressTapUntil = 0;
    var touchStartX = 0;
    var touchStartY = 0;
    var touchMoved = false;
    var touchTracking = false;
    var rafId = 0;
    var SWIPE_TAP_THRESHOLD = 12;
    var TAP_SUPPRESS_MS = 420;

    if (defaultBg) {
      section.style.setProperty('--kev-active-bg', defaultBg);
    }

    if (!track || !prevBtn || !nextBtn) return;

    function getCards() {
      return Array.prototype.slice.call(track.querySelectorAll('.kev-hair-needs__item'));
    }

    function getVisibleCards() {
      if (window.matchMedia('(min-width: 1200px)').matches) return 3;
      if (window.matchMedia('(max-width: 749px)').matches) return 1;
      if (window.matchMedia('(orientation: landscape)').matches) return 3;
      return 2;
    }

    function getMaxIndex(cards) {
      return Math.max(0, cards.length - getVisibleCards());
    }

    function getStep() {
      var cards = getCards();
      if (!cards.length) return 0;
      var gapValue = parseFloat(window.getComputedStyle(track).gap || '0') || 0;
      return cards[0].getBoundingClientRect().width + gapValue;
    }

    function getCurrentIndex(cards, step) {
      if (!cards.length || !step) return 0;
      return Math.max(0, Math.min(getMaxIndex(cards), Math.round(track.scrollLeft / step)));
    }

    function renderDots(count) {
      if (!dotsWrap || dotCount === count) return;
      dotCount = count;
      dotsWrap.innerHTML = '';
      for (var i = 0; i < count; i += 1) {
        var dot = document.createElement('span');
        dot.className = 'kev-hair-needs__dot';
        dotsWrap.appendChild(dot);
      }
    }

    function syncMobileStatus(cards, sliderActive, currentIndex) {
      if (!status) return;
      status.hidden = !sliderActive;

      if (!sliderActive) {
        dotCount = -1;
        if (dotsWrap) dotsWrap.innerHTML = '';
        if (counter) counter.textContent = '1 von 1';
        return;
      }

      var pageCount = getMaxIndex(cards) + 1;
      renderDots(pageCount);

      if (dotsWrap) {
        var dots = dotsWrap.children;
        for (var i = 0; i < dots.length; i += 1) {
          dots[i].classList.toggle('is-active', i === currentIndex);
        }
      }

      if (counter) {
        counter.textContent = currentIndex + 1 + ' von ' + pageCount;
      }
    }

    function syncSlider() {
      var cards = getCards();
      var sliderActive = cards.length > getVisibleCards();
      var step = getStep();
      var currentIndex = getCurrentIndex(cards, step);
      var maxIndex = getMaxIndex(cards);

      section.classList.toggle('kev-hair-needs--slider-active', sliderActive);
      prevBtn.hidden = !sliderActive;
      nextBtn.hidden = !sliderActive;
      syncMobileStatus(cards, sliderActive, currentIndex);

      if (!sliderActive) {
        prevBtn.disabled = true;
        nextBtn.disabled = true;
        track.scrollLeft = 0;
        return;
      }

      prevBtn.disabled = currentIndex <= 0;
      nextBtn.disabled = currentIndex >= maxIndex;
    }

    function setBg(raw) {
      var bg = normalizeBg(raw);
      if (bg) {
        section.style.setProperty('--kev-active-bg', bg);
      }
    }

    function updateBgFromScroll() {
      if (!section.classList.contains('kev-hair-needs--active-bg')) return;
      var cards = getCards();
      var step = getStep();
      var index = step ? getCurrentIndex(cards, step) : 0;
      var card = cards[index];
      if (card && card.dataset.bg) {
        setBg(card.dataset.bg);
      } else if (defaultBg) {
        setBg(defaultBg);
      }
    }

    function scheduleSync() {
      if (rafId) return;
      rafId = window.requestAnimationFrame(function () {
        rafId = 0;
        syncSlider();
        updateBgFromScroll();
      });
    }

    function moveSlider(direction) {
      var step = getStep();
      if (!step) return;

      var cards = getCards();
      var maxIndex = getMaxIndex(cards);
      var currentIndex = Math.round(track.scrollLeft / step);
      var nextIndex = Math.max(0, Math.min(maxIndex, currentIndex + direction));

      track.scrollTo({
        left: nextIndex * step,
        behavior: 'smooth'
      });
    }

    prevBtn.addEventListener('click', function (event) {
      event.preventDefault();
      moveSlider(-1);
    });

    nextBtn.addEventListener('click', function (event) {
      event.preventDefault();
      moveSlider(1);
    });

    track.addEventListener(
      'touchstart',
      function (event) {
        if (!event.touches || event.touches.length !== 1) {
          touchTracking = false;
          return;
        }
        var touch = event.touches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        touchMoved = false;
        touchTracking = true;
      },
      { passive: true }
    );

    track.addEventListener(
      'touchmove',
      function (event) {
        if (!touchTracking || !event.touches || !event.touches.length) return;
        var touch = event.touches[0];
        var deltaX = Math.abs(touch.clientX - touchStartX);
        var deltaY = Math.abs(touch.clientY - touchStartY);
        if (Math.max(deltaX, deltaY) > SWIPE_TAP_THRESHOLD) {
          touchMoved = true;
        }
      },
      { passive: true }
    );

    function finalizeTouchGesture() {
      if (touchMoved) {
        suppressTapUntil = Date.now() + TAP_SUPPRESS_MS;
      }
      touchTracking = false;
      touchMoved = false;
    }

    track.addEventListener('touchend', finalizeTouchGesture, { passive: true });
    track.addEventListener('touchcancel', finalizeTouchGesture, { passive: true });

    section.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest('.kev-hair-needs__card[href]');
        if (!link) return;
        if (Date.now() < suppressTapUntil) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );

    if (section.classList.contains('kev-hair-needs--active-bg')) {
      getCards().forEach(function (card) {
        card.addEventListener('mouseenter', function () {
          if (card.dataset.bg) setBg(card.dataset.bg);
          track.classList.add('is-card-hovered');
        });

        card.addEventListener('mouseleave', function () {
          track.classList.remove('is-card-hovered');
        });
      });
    }

    track.addEventListener('scroll', scheduleSync, { passive: true });
    window.addEventListener('resize', scheduleSync);
    syncSlider();
    updateBgFromScroll();
  }

  function observeSections(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll(sectionSelector);

    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(sections, activateSection);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          activateSection(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '300px 0px',
        threshold: 0.05
      }
    );

    Array.prototype.forEach.call(sections, function (section) {
      if (section.dataset.hairNeedsObserved === '1') return;
      section.dataset.hairNeedsObserved = '1';
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observeSections(document);
    });
  } else {
    observeSections(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    observeSections(event.target || document);
  });
})();
